import React, {useState} from 'react'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'

import FilesRow from '../../components/FilesRow'
import {File} from '../../types/file'


type EditExistingFilesProps = {
  existingFiles: File[],
  setDeleteFileIds: (deleteFileIds: string[]) => void,
}

export default function EditExistingFiles(
  {existingFiles, setDeleteFileIds}: EditExistingFilesProps
): JSX.Element {
  const [showFiles, setShowFiles] = useState<File[]>(existingFiles)
  const [deleteIds, setDeleteIds] = useState<string[]>([])

  const updateDeleteIds = (id: string) => {
    const newDeleteIds = [...deleteIds, id]
    setDeleteIds(newDeleteIds)
    setDeleteFileIds(newDeleteIds)
  }

  const updateShowFiles = (id: string) => {
    const newShowFiles = showFiles.filter((f) => f.id && f.id !== id)
    setShowFiles(newShowFiles)
  }

  const onDelete = (id: string) => {
    // TS forces us to have a default ID value here, so I'm checking ID actually exists
    if (id.length > 0) {
      updateDeleteIds(id)
      updateShowFiles(id)
    }
  }

  return showFiles.length > 0
    ? (
      <Grid item xs={12} sx={{paddingBottom: 4}}>
        <Typography color="primary">Current Files:</Typography>
        <FilesRow
          files={showFiles}
          onDelete={onDelete}
        />
      </Grid>
    )
    : <></>
}
